
import { Team } from '@/types/database';
import { TeamCardWithMemberCount } from './TeamCardWithMemberCount';

interface TeamsGridProps {
  teams: Team[];
  loading?: boolean;
  onTeamSelect?: (team: Team) => void;
}

export const TeamsGrid = ({ teams, loading, onTeamSelect }: TeamsGridProps) => {
  if (loading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {[...Array(6)].map((_, i) => (
          <div key={i} className="animate-pulse">
            <div className="bg-gray-800 rounded-lg h-80"></div>
          </div>
        ))}
      </div>
    );
  }

  if (teams.length === 0) {
    return (
      <div className="text-center py-12">
        <div className="text-gray-400 text-lg mb-2">No teams found</div>
        <div className="text-gray-500">Try adjusting your search criteria</div>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {teams.map((team) => (
        <TeamCardWithMemberCount
          key={team.team_id}
          team={team}
          sport={['Football', 'Basketball', 'Soccer', 'Baseball'][Math.floor(Math.random() * 4)]}
          location={['Atlanta, GA', 'Birmingham, AL', 'Nashville, TN', 'Charlotte, NC'][Math.floor(Math.random() * 4)]}
          onViewDetails={() => onTeamSelect?.(team)}
        />
      ))}
    </div>
  );
};
